import React from 'react';
import PropTypes from 'prop-types';
import { Svg, G, Path } from '@dbk/ui-svg';
import { pure } from '@dbk/ui-react-utils';

function FilterIcon(props) {
  const {
    ...svgProps
  } = props;

  return (
    <Svg {...svgProps}
      viewBox="0 0 20 20"
    >
      <G fill="#FFF">
        <Path d="M2.5 5C3.75678571 5 4.79714286 4.06642857 4.97142857 2.85714286L18.9285714 2.85714286C19.1260714 2.85714286 19.2857143 2.6975 19.2857143 2.5 19.2857143 2.3025 19.1260714 2.14285714 18.9285714 2.14285714L4.97142857 2.14285714C4.79714286.933571429 3.75678571 0 2.5 0 1.12142857 0 0 1.12178571 0 2.5 0 3.87821429 1.12142857 5 2.5 5zM2.5.714285714C3.48464286.714285714 4.28571429 1.51535714 4.28571429 2.5 4.28571429 3.48464286 3.48464286 4.28571429 2.5 4.28571429 1.51535714 4.28571429.714285714 3.48464286.714285714 2.5.714285714 1.51535714 1.51535714.714285714 2.5.714285714zM16.7857143 15C15.5289286 15 14.4885714 15.9335714 14.3142857 17.1428571L.357142857 17.1428571C.16 17.1428571 0 17.3025 0 17.5 0 17.6975.16 17.8571429.357142857 17.8571429L14.3142857 17.8571429C14.4885714 19.0664286 15.5289286 20 16.7857143 20 18.1639286 20 19.2857143 18.8782143 19.2857143 17.5 19.2857143 16.1217857 18.1639286 15 16.7857143 15zM16.7857143 19.2857143C15.8010714 19.2857143 15 18.4846429 15 17.5 15 16.5153571 15.8010714 15.7142857 16.7857143 15.7142857 17.7703571 15.7142857 18.5714286 16.5153571 18.5714286 17.5 18.5714286 18.4846429 17.7703571 19.2857143 16.7857143 19.2857143zM18.9285714 9.64285714L12.2742857 9.64285714C12.1328571 8.35642857 11.0403571 7.35214286 9.71678571 7.35214286 8.39321429 7.35214286 7.30071429 8.35678571 7.15928571 9.64285714L.357142857 9.64285714C.16 9.64285714 0 9.8025 0 10 0 10.1975.16 10.3571429.357142857 10.3571429L7.18178571 10.3571429C7.38785714 11.5714286 8.44464286 12.5 9.71678571 12.5 10.9889286 12.5 12.0453571 11.5714286 12.2514286 10.3571429L18.9285714 10.3571429C19.1260714 10.3571429 19.2857143 10.1975 19.2857143 10 19.2857143 9.8025 19.1260714 9.64285714 18.9285714 9.64285714zM9.71678571 11.7857143C8.69142857 11.7857143 7.85714286 10.9514286 7.85714286 9.92607143 7.85714286 8.90071429 8.69142857 8.06642857 9.71678571 8.06642857 10.7421429 8.06642857 11.5764286 8.90071429 11.5764286 9.92607143 11.5764286 10.9514286 10.7421429 11.7857143 9.71678571 11.7857143z" />
      </G>
    </Svg>
  );
}

FilterIcon.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
};

FilterIcon.defaultProps = {
  height: 16,
  width: 16,
};

export default pure(FilterIcon);
